import { useApiClient } from '@hetivo/hetivo-lib-front-utils';
import type { Location } from '@hetivo/hetivo-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createLocationApi, locationKeys } from '../api';
import type { CreateLocationParams } from '../api';

export function useCreateLocation(): UseMutationResult<Location, Error, CreateLocationParams> {
  const client = useApiClient('admin-auth');
  const api = createLocationApi(client);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateLocationParams) => api.createLocation(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: locationKeys.all });
    },
  });
}
